export const ZOOM_MIN = 1
export const ZOOM_MAX = 8

export const ZOOM_STEP = 0.25
